import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import {
  ControlContainer,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { Partner } from '@core/core.types';
import { LanguageState } from '@core/store/languages/languages.state';
import { PartnersState } from '@core/store/partners/partners.state';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { SelectOptionComponent } from '@shared/components/select/select-option/select-option.component';
import { SelectComponent } from '@shared/components/select/select.component';
import { ValidationErrorComponent } from '@shared/components/validation-error/validation-error.component';
import { RequirePermissionDirective } from '@shared/directives/require-permission.directive';
import { controlContainerProvider } from '@shared/helpers';
import { DisplayNamePipe } from '@shared/pipes/display-name.pipe';
import { map, startWith, switchMap } from 'rxjs';

@Component({
  selector: 'app-service-data-form-other-information',
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    ValidationErrorComponent,
    SelectComponent,
    SelectOptionComponent,
    DisplayNamePipe,
    RequirePermissionDirective,
  ],
  templateUrl: './service-data-form-other-information.component.html',
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDataFormOtherInformationComponent implements OnInit {
  private controlContainer = inject(ControlContainer);
  private store = inject(Store);
  private cdr = inject(ChangeDetectorRef);

  @Input() id: string;

  protected partner: Partner;
  protected languages = this.store.selectSignal(LanguageState.getLanguages);

  protected get form() {
    return this.controlContainer.control as FormGroup;
  }

  ngOnInit(): void {
    this.form
      .get('partnerId')
      .valueChanges.pipe(
        startWith(this.form.get('partnerId').value),
        switchMap((partner) =>
          this.store
            .select(PartnersState.getPartnerById)
            .pipe(map((getPartner) => getPartner(partner)))
        )
      )
      .subscribe((partner) => {
        this.partner = partner;

        if (
          this.partner?.reportLanguageIds?.length ||
          this.partner?.languageIds?.length
        ) {
          this.form.get('reportLanguageId').enable();
        } else {
          this.form.get('reportLanguageId').disable();
        }

        this.cdr.markForCheck();
      });
  }
}
